import React, { useState, useEffect } from 'react';
//import Logger from '../Logger';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withRoomContext } from '../RoomContext';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import Dialog from '@material-ui/core/Dialog';
import DialogContentText from '@material-ui/core/DialogContentText';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Grid from '@material-ui/core/Grid';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import { useHistory} from 'react-router-dom';

const styles = (theme) =>
	({
		root :
		{
			display              : 'flex',
			width                : '100%',
			height               : '100%',
			backgroundColor      : 'var(--background-color)',
			background            : 'var(--background-alt-radial-gradient)',
			//backgroundImage      : `url(${window.config ? window.config.background : null})`,
			backgroundAttachment : 'fixed',
			backgroundPosition   : 'center',
			backgroundSize       : 'cover',
			backgroundRepeat     : 'no-repeat'
		},
		dialogTitle :
		{
			background      : 'var(--background-color-blue)'
		},
		dialogPaper :
		{
			width                          : '30vw',
			padding                        : theme.spacing(2),
			[theme.breakpoints.down('lg')] :
			{
				width : '40vw'
			},
			[theme.breakpoints.down('md')] :
			{
				width : '50vw'
			},
			[theme.breakpoints.down('sm')] :
			{
				width : '70vw'
			},
			[theme.breakpoints.down('xs')] :
			{
				width : '90vw'
			}
		},
		accountButton :
		{
			padding  : 0
		},
		accountButtonAvatar :
		{
			width  : 50,
			height : 50
		},
		green :
		{
			color : 'rgba(0, 153, 0, 1)'
		},
		red :
		{
			color : 'rgba(153, 0, 0, 1)',
			fontSize: '14px'
		},
		joinButton :
		{
			background : '#2e7031',
			color      : 'white',
			'&:hover'  : {
				backgroundColor : '#2e7031'
			}
		},
		mediaDevicesAnySelectedButton :
		{
			'& .Mui-selected' : {
				color           : 'white',
				backgroundColor : '#5F9B2D',
				'&:hover'       : {
					color           : 'white',
					backgroundColor : '#5F9B2D'
				} }

		},

		mediaDevicesNoneSelectedButton :
	{
			'& .Mui-selected' : {
				color           : 'white',
				backgroundColor : '#f50057',
				'&:hover'       : {
					color           : 'white',
					backgroundColor : '#f50057'
				} }

		},

		loginLabel :
	{
			fontSize : '12px'
		}

		});

//const logger = new Logger('MeetingRoomDialog');

const DialogTitle = withStyles((theme) => ({
	root :
	{
		margin        : 0,
		padding       : theme.spacing(1),
		paddingBottom : theme.spacing(0)
						}
}))(MuiDialogTitle);

const DialogContent = withStyles((theme) => ({
	root :
	{
		padding    : theme.spacing(2),
		paddingTop : theme.spacing(0)
	}
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
	root :
	{
		margin  : 0,
		padding : theme.spacing(1)
	}
}))(MuiDialogActions);

const getNormalizedRoomId = (value = '') =>
{
	const trimmedValue = value.trim().toLowerCase();

	if (!trimmedValue) return '';

	try
	{
		const parsedUrl = new URL(trimmedValue);
		const pathnameSegments = parsedUrl.pathname.split('/').filter(Boolean);
		return pathnameSegments[pathnameSegments.length - 1] || '';
	}
	catch (error)
	{
		const sanitizedValue = trimmedValue.split('?')[0].split('#')[0].replace(/\/+$/, '');
		const valueSegments = sanitizedValue.split('/').filter(Boolean);
		return valueSegments[valueSegments.length - 1] || sanitizedValue;
	}
};

const MeetingRoomDialog = ({
	roomClient,
	room,
	mediaPerms,
	displayName,
	displayNameInProgress,
	loggedIn,
	myPicture,
	changeDisplayName,
	setMediaPerms,
	classes,
	setAudioMuted,
	setVideoMuted,
	locale,
	localesList
}) =>
{
	const history = useHistory();

	const intl = useIntl();

	const [ pageError, setPageError ] = useState(false);
	const [ roomId, setRoomId ] = useState(
		getNormalizedRoomId(decodeURIComponent(window.location.pathname.slice(1)) || '')
	);
	
	
	
	useEffect(() =>
	{
		//setPageError("Meeting room does not exist. Please check the URL or contact the sender who has shared this meeting room URL")
	});

	const handleJoinUsingEnterKey = (event) =>
	{
		if (event.key === 'Enter') document.getElementById('joinButton').click();
	};

	const handleFocus = (event) => event.target.select();

	const handleJoin = () =>
	{
		const normalizedRoomId = getNormalizedRoomId(roomId);

		setRoomId(normalizedRoomId);
		console.log("[handleJoin]....", normalizedRoomId);
		const roomIdArr = normalizedRoomId.split('-');
		if(normalizedRoomId.length < 5){
			setPageError("Meeting room ID is invalid. Please re-check the room ID or contact the sender who has shared this meeting room URL")
		}
		else{
			setPageError(false);
			history.push("/"+normalizedRoomId);
		}
	}


	return (
		
		<div className={classes.root}>
			<Dialog
				open
				onKeyDown={handleJoinUsingEnterKey}
				classes={{
					paper : classes.dialogPaper
				}}
			>

				<DialogTitle className={classes.dialogTitle}>
					<Grid
						container
						direction='row'
						justify='space-between'
						alignItems='center'
					>
						<Grid item>
							{ window.config.logo !=='' ?
								<img alt='Logo' src={window.config.logo} /> :
								<Typography variant='h5'> {window.config.title} </Typography>
							}
						</Grid>

						<Grid item>
							<Grid
								container
								direction='row'
								justify='flex-end'
								alignItems='center'
							>
							</Grid>
						</Grid>
					</Grid>
				</DialogTitle>
				<DialogContent>
					<hr />
					
					<DialogContentText variant='h5' gutterBottom>
						<FormattedMessage
							id='room.licenseCheckMessageTitle'
							defaultMessage={
								'Welcome to rediffOnScreen meetings'
							}
						/>
					</DialogContentText>
					{pageError &&
						<DialogContentText className={classes.red} variant='h6' gutterBottom>
							<FormattedMessage
								id='room.licenseCheckMessage'
								defaultMessage={
									pageError
								}
							/>
						</DialogContentText>
					}
					<DialogContentText variant='subtitle' gutterBottom>
						<FormattedMessage
							id='room.roomJoiningMessage'
							defaultMessage={
								'If you know the meeting room ID, please enter it in the following box or check your email/message for the meeting room URL'
							}
						/>
						<TextField
							autoFocus
							id='roomId'
							label={intl.formatMessage({
								id             : 'label.roomID',
								defaultMessage : 'Room ID'
							})}
							value={roomId}
							variant='outlined'
							margin='normal'
							InputProps={{
								startAdornment : (
									<InputAdornment position='start'>
										<MeetingRoomIcon />
									</InputAdornment>
								)
							}}
							onChange={(event) =>
							{
								const { value } = event.target;

								setRoomId(getNormalizedRoomId(value));

							}}
							onFocus={handleFocus}
							onBlur={() =>
							{
							}}
							fullWidth
						/>
					</DialogContentText>
				</DialogContent>

				<DialogActions>
					<Grid item>
						<Button
							onClick={handleJoin}
							variant='contained'
							color='primary'
							id='joinButton'
							>
								<FormattedMessage
								id='label.join'
								defaultMessage='Join'
								/>
						</Button>
					</Grid>
				</DialogActions>					
			</Dialog>
		</div>

	);
};

MeetingRoomDialog.propTypes =
{
	roomClient            : PropTypes.any.isRequired,
	room                  : PropTypes.object.isRequired,
	roomId                : PropTypes.string.isRequired,
	loginEnabled          : PropTypes.bool.isRequired,
	loggedIn              : PropTypes.bool.isRequired,
	classes               : PropTypes.object.isRequired
};


const mapStateToProps = (state) =>
{
	return {
		room                  : state.room,
		mediaPerms            : state.settings.mediaPerms,
		displayName           : state.settings.displayName,
		displayNameInProgress : state.me.displayNameInProgress,
		loginEnabled          : state.me.loginEnabled,
		loggedIn              : state.me.loggedIn,
		myPicture             : state.me.picture,
		locale                : state.intl.locale,
		localesList           : state.intl.list
	};
};

const mapDispatchToProps = (dispatch) =>
{
	return {
		
	};
};

//export default withStyles(styles)(MeetingRoomDialog);
export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room.signInRequired === next.room.signInRequired &&
				prev.me.loginEnabled === next.me.loginEnabled &&
				prev.me.loggedIn === next.me.loggedIn
			);
		}
	}
)(withStyles(styles)(MeetingRoomDialog)));
